import UiValidatedJson from "../UiValidatedJson/UiValidatedJson.vue";

import JsonOptionsMixin from "./JsonOptionsMixin";
import UIComponentMixin from "../UIComponentMixin";

import {
  cloneDeep,
  omit,
} from "lodash-es";


// @vue/component
export default {
  name: "UiIconConfig",
  components: {
    UiValidatedJson,
  },
  mixins: [
    JsonOptionsMixin,
    UIComponentMixin,
  ],
  props: {
    model: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    modelLocal() {
      const MODEL = cloneDeep(this.model) || {};
      MODEL.preview = cloneDeep(MODEL);
      return MODEL;
    },
  },
  methods: {
    changeLocal({ model }) {
      this.onInput_mixin({ value: omit(model, ["preview"]) });
    },
  },
};
